import React, { useState } from "react";
import {
  Box,
  Button,
  makeStyles,
  Snackbar,
  withStyles,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import SendIcon from "@material-ui/icons/Send";
import { useLocation } from "react-router-dom";
import { routes } from "../../constants/routes";
const CssTextField = withStyles({
  root: {
    "& label": {
      color: "#fff",
    },
    "& label.Mui-focused": {
      color: "#fff",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#839192",
      },
      "&:hover fieldset": {
        borderColor: "#fff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#fff",
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    backgroundColor: "#36404b",
    display: "flex",
    flexDirection: "column",
    // padding: 10,
    paddingRight: "3%",
    paddingLeft: "3%",
    // justifyContent:'center',
    [theme.breakpoints.up("sm")]: {
      //height:'60px',
    },
  },
  subContainer: {
    marginTop: "20px",
    marginBottom: "50px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      marginBottom: "80px",
    },
  },
  aboutSection: {
    color: "#fff",
    marginLeft: "2%",
    marginBottom: "20px",
    width: "94%",
    [theme.breakpoints.up("md")]: {
      width: "30%",
      marginBottom: "0px",
    },
  },
  contactSection: {
    color: "#fff",
    marginLeft: "2%",
    marginBottom: "20px",
    width: "94%",
    [theme.breakpoints.up("md")]: {
      width: "40%",
      marginBottom: "0px",
    },
  },
  filterSection: {
    color: "#fff",
    marginLeft: "2%",
    marginBottom: "20px",
    width: "94%",
    [theme.breakpoints.up("md")]: {
      width: "15%",
      marginBottom: "0px",
    },
  },
  catelogSection: {
    color: "#fff",
    marginLeft: "2%",
    marginBottom: "20px",
    width: "94%",
    [theme.breakpoints.up("md")]: {
      width: "10%",
      marginBottom: "0px",
    },
  },
  form: {
    color: "#fff",
    marginLeft: "2%",
    marginBottom: "20px",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "50%",
      marginBottom: "0px",
    },
  },
  // container:{
  //  width:'100%',
  //  display:'flex',
  //  justifyContent:'space-between',
  // },
  linkSection: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
  },
  title: {
    marginTop: "20px",
    marginBottom: "20px",
    fontWeight: 700,
    fontSize: "14px",
    color: "#fff",
    [theme.breakpoints.up("sm")]: {
      fontSize: "18px",
      marginBottom: "40px",
    },
  },
  content: {
    fontSize: "14.5px",
    lineHeight: 1.5,
  },
  link: {
    color: "#fff",
    cursor: "pointer",
  },
  contact: {
    marginLeft: "30px",
    color: "#fff",
    fontSize: "15px",
  },
  contactTitle: {
    fontSize: "18px",
    fontWeight: 500,
    marginBottom: "5px",
  },
  copyRight: {
    backgroundColor: "#2c343d",
    textAlign: "center",
    paddingTop: "20px",
    paddingBottom: "20px",
    color: "#fff",
    fontWeight: "bold",
  },
  copyRightCondition: {
    marginTop: "calc(25% + 60px)",
    // position: 'fixed',
    bottom: 0,
    width: "100%",
    backgroundColor: "#2c343d",
    textAlign: "center",
    paddingTop: "20px",
    paddingBottom: "20px",
    color: "#fff",
    fontWeight: "bold",
  },
  // copyRightContent: {
  //   position: 'relative',
  //   top: '50%',
  //   transform: 'translateY(-50%)',
  // },
  textField: {
    width: "94%",
  },
  button: {
    // margin: theme.spacing(1),
    width: "150px",
    backgroundColor: "#B20502",
    "&:hover": {
      backgroundColor: "#1C2833",
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  const location = useLocation();
  let condition = true;
  if (
    location.pathname === routes.ABOUTUS ||
    location.pathname === routes.CONTACT
  ) {
    condition = false;
  }

  const [contactDetails, setContactDetails] = useState({
    name: "",
    phone_number: "",
    emailId: "",
    message: "",
  });

  const [error, setError] = useState({
    name: "",
    phone_number: "",
    emailId: "",
    message: "",
  });

  function handleChange(e) {
    let value = e.target.value;
    let name = e.target.name;

    setContactDetails({ ...contactDetails, [name]: value });
    setError({ ...error, [name]: "" });
  }

  function submitContactDetails(e) {
    e.preventDefault();
    if (
      contactDetails.name.length === 0 &&
      contactDetails.phone_number.length === 0 &&
      contactDetails.emailId.length === 0 &&
      contactDetails.message.length === 0
    ) {
      setError({
        ...error,
        name: "Please enter name.",
        phone_number: "Please enter phone number.",
        emailId: "Please enter email ID",
        message: "Please enter message.",
      });
    } else if (contactDetails.name.length === 0) {
      setError({
        ...error,
        name: "Please enter name.",
      });
      if (contactDetails.phone_number.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          phone_number: "Please enter phone number",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            phone_number: "Please enter phone no.",
            message: "Please enter messsage.",
          });
        } else if (contactDetails.emailId.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            phone_number: "Please enter phone no.",
            emailId: "Please enter email ID.",
          });
        }
      } else if (contactDetails.emailId.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          emailId: "Please enter email ID.",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            name: "Please enter name.",
            emailId: "Please enter email ID.",
            message: "Please enter message.",
          });
        }
      } else if (contactDetails.message.length === 0) {
        setError({
          ...error,
          name: "Please enter name.",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.phone_number.length === 0) {
      setError({
        ...error,
        phone_number: "Please enter phone number",
      });
      if (contactDetails.emailId.length === 0) {
        setError({
          ...error,
          phone_number: "Please enter phone number",
          emailId: "Please enter email ID.",
        });
        if (contactDetails.message.length === 0) {
          setError({
            ...error,
            phone_number: "Please enter phone number",
            emailId: "Please enter email ID.",
            message: "Please enter message.",
          });
        }
      } else if (contactDetails.message.length === 0) {
        setError({
          ...error,
          phone_number: "Please enter phone number",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.emailId.length === 0) {
      setError({
        ...error,
        emailId: "Please enter email ID.",
      });
      if (contactDetails.message.length === 0) {
        setError({
          ...error,
          emailId: "Please enter email ID.",
          message: "Please enter message.",
        });
      }
    } else if (contactDetails.message.length === 0) {
      setError({
        ...error,
        message: "Please enter message.",
      });
    } else if (contactDetails.phone_number.match(/^[0-9]+$/) === null) {
      // check phone number have only numbers or not
      setError({
        ...error,
        phone_number: "Phone number must be have only numbers.",
      });
    } else if (
      contactDetails.emailId.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      ) === null
    ) {
      // check email id is valid or not
      setError({
        ...error,
        emailId: "Please enter valid Email ID.",
      });
    } else {
      //when all validations are done then API call for send email
      fetch(`${process.env.REACT_APP_API_ENDPOINT}/send-mail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // // "ngrok-skip-browser-warning": "true",
        },
        body: JSON.stringify(contactDetails),
      })
        .then((response) => response.json())
        .then((json) => {
          console.log("Status", json);
          if (json.hasOwnProperty("status")) {
            if (json.status === "Mail Sent Successfully") {
              // after successfully submitted form show success message
              setSuccessSubmit(true);
            }
          }
        });
      setContactDetails({
        ...contactDetails,
        name: "",
        phone_number: "",
        emailId: "",
        message: "",
      });
    }
  }

  const [successSubmit, setSuccessSubmit] = useState(false);
  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSubmit(false);
  };

  return (
    <>
      {condition === true && (
        <div className={classes.mainContainer}>
          <div className={classes.subContainer}>
            {/* <div className={classes.aboutSection}>
            <Box className={classes.title}>ABOUT US</Box>

            <Box className={classes.content}>
              <p>
                GuardPlus is an automobile filter manufacturer and distributor
                focusing on light, medium, and heavy-duty parts. Our filters are
                manufactured to the highest quality in the marketplace and meet the
                original equipment fit, form and function. We aim to be the industry leader
                in providing the best quality products and services. Customer satisfaction
                is our #1 priority. From your initial contact to after-the-scale
                support, our team is committed to providing you with cost-effective
                solutions to your filtration needs.
              </p>
            </Box>
          </div> */}
            <div className={classes.contactSection}>
              <Box className={classes.title}>CONTACT US</Box>
              {/* <div style={{ display: "flex" }}>
            <div className={classes.linkSection}>
              <Link href="#" className={classes.link}>
                Home
              </Link>
              <Link href="#" className={classes.link}>
                Catelog
              </Link>
              <Link href="#" className={classes.link}>
                Contact us
              </Link>
            </div>
            <div className={classes.linkSection}>
              <Link href="#" className={classes.link}>
                Products
              </Link>
              <Link href="#" className={classes.link}>About Us</Link>
            </div>
          </div> */}
              <Box className={classes.content}>
                <Link
                  className={classes.link}
                  href="mailto:sales@gpautocomp.com"
                >
                  sales@gpautocomp.com
                </Link>
                <Box style={{ marginBottom: "20px" }}>+91 9979842040</Box>
                <Box>
                  Address: Plot No 1108, Phase – II, GIDC, Chhatral, Tal Kalol,
                  Dist Gandhinagar – 382729.
                  {/* SysTrack Solution Pvt. Ltd. FF# 11-12, Darshanam
                  Elite,Sun Pharma Road, Atladara,Vadodara-390012, Gujarat India. */}
                </Box>
              </Box>
            </div>

            <div className={classes.filterSection}>
              <Box className={classes.title}>PRODUCTS</Box>

              <Box style={{ marginBottom: "12px", fontSize: "16px" }}>
                <Link href={routes.OILFILTER} className={classes.link}>
                  Oil Filters
                </Link>
              </Box>
              <Box style={{ marginBottom: "12px", fontSize: "16px" }}>
                <Link href={routes.AIRFILTER} className={classes.link}>
                  Air Filters
                </Link>
              </Box>
              <Box style={{ marginBottom: "12px", fontSize: "16px" }}>
                <Link href={routes.FUELFILTER} className={classes.link}>
                  Fuel Filters
                </Link>
              </Box>
              <Box style={{ marginBottom: "12px", fontSize: "16px" }}>
                <Link href={routes.PACKAGINGSOLUTIONS} className={classes.link}>
                  Packaging Solutions
                </Link>
              </Box>
            </div>

            {/* <div className={classes.catelogSection}>
            <Box className={classes.title}>CATALOG</Box>
          </div> */}

            <div className={classes.form}>
              <Box className={classes.title}>SEND US INQUIRY</Box>
              <Box>
                <form>
                  <Box style={{ display: "flex", flexDirection: "column" }}>
                    <Box style={{ paddingBottom: "10px" }}>
                      <CssTextField
                        className={classes.textField}
                        label="Name*"
                        variant="outlined"
                        id="name"
                        size="small"
                        inputProps={{ style: { color: "#fff" } }}
                        name="name"
                        value={contactDetails.name}
                        onChange={(e) => handleChange(e)}
                        error={error.name ? true : false}
                        helperText={error.name}
                      />
                    </Box>
                    <Box style={{ paddingBottom: "10px" }}>
                      <CssTextField
                        className={classes.textField}
                        label="Phone Number*"
                        variant="outlined"
                        id="phone-no"
                        size="small"
                        inputProps={{ style: { color: "#fff" } }}
                        name="phone_number"
                        value={contactDetails.phone_number}
                        onChange={(e) => handleChange(e)}
                        error={error.phone_number ? true : false}
                        helperText={error.phone_number}
                      />
                    </Box>
                    <Box style={{ paddingBottom: "10px" }}>
                      <CssTextField
                        className={classes.textField}
                        label="Email*"
                        variant="outlined"
                        id="email id"
                        size="small"
                        inputProps={{ style: { color: "#fff" } }}
                        name="emailId"
                        type="email"
                        value={contactDetails.emailId}
                        onChange={(e) => handleChange(e)}
                        error={error.emailId ? true : false}
                        helperText={error.emailId}
                      />
                    </Box>
                    <Box style={{ paddingBottom: "10px" }}>
                      <CssTextField
                        className={classes.textField}
                        id="outlined-multiline-static"
                        label="Message*"
                        multiline
                        minRows={3}
                        variant="outlined"
                        inputProps={{ style: { color: "#fff" } }}
                        name="message"
                        value={contactDetails.message}
                        onChange={(e) => handleChange(e)}
                        error={error.message ? true : false}
                        helperText={error.message}
                      />
                    </Box>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      endIcon={<SendIcon />}
                      onClick={(e) => submitContactDetails(e)}
                    >
                      Send
                    </Button>
                  </Box>
                </form>
              </Box>
            </div>
          </div>

          {/* <div className={classes.subContainer}>
        <div className={classes.section}>
          <div style={{ display: "flex" }}>
            <Fab>
              <PhoneIcon />
            </Fab>
            <div className={classes.contact}>
              <Box className={classes.contactTitle}>Contact Us Now</Box>
              <Link style={{ color: "#fff", cursor: "pointer" }}>
                +91-991-677-9748
              </Link>
            </div>
          </div>
        </div>

        <div className={classes.section}>
          <div style={{ display: "flex" }}>
            <Fab>
              <EmailIcon />
            </Fab>
            <div className={classes.contact}>
              <Box className={classes.contactTitle}>Email Us</Box>
              <Link style={{ color: "#fff", cursor: "pointer" }}>
                info@sys-track.com
              </Link>
            </div>
          </div>
        </div>

        <div className={classes.section}>
          <div style={{ display: "flex" }}>
            <Fab>
              <PrintIcon />
            </Fab>
            <div className={classes.contact}>
              <Box className={classes.contactTitle}> Opening Hours</Box>
              <Box>Mon - Sat : 9am to 7pm</Box>
            </div>
          </div>
        </div>
      </div> */}
        </div>
      )}
      <div
        className={
          condition === false ? classes.copyRightCondition : classes.copyRight
        }
      >
        <Box>Copyrights © GuardPlus 2022 . All Rights Reserved</Box>
      </div>

      {/* after successfully submitted form show success message */}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        ContentProps={{
          style: { background: "green" },
        }}
        open={successSubmit}
        autoHideDuration={5000}
        onClose={handleCloseSuccess}
        message="Your form has been submitted successfully!"
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleCloseSuccess}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </>
  );
};
export default Footer;
